import type { CurrentUser, UserRole, UserStatus } from "./auth";
import { apiRequest } from "./client";

export interface UserListItem extends CurrentUser {
  created_at: string;
  updated_at: string;
}

export interface UserListResponse {
  items: UserListItem[];
  total: number;
  page: number;
  page_size: number;
}

export interface UserFilters {
  page: number;
  pageSize: number;
  search?: string;
  role?: UserRole;
  status?: UserStatus;
}

export function fetchUsers(filters: UserFilters, signal?: AbortSignal): Promise<UserListResponse> {
  const params = new URLSearchParams({
    page: String(filters.page),
    page_size: String(filters.pageSize),
  });
  if (filters.search) params.set("search", filters.search);
  if (filters.role) params.set("role", filters.role);
  if (filters.status) params.set("status", filters.status);
  return apiRequest(`/api/v1/admin/users?${params}`, { signal });
}

export function createUser(payload: {
  username: string;
  name: string;
  role: UserRole;
  initial_password: string;
}): Promise<UserListItem> {
  return apiRequest("/api/v1/admin/users", { method: "POST", body: JSON.stringify(payload) });
}

export function updateUser(
  userId: string,
  payload: { name: string; role: UserRole; status: UserStatus; version: number },
): Promise<UserListItem> {
  return apiRequest(`/api/v1/admin/users/${userId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function resetUserPassword(userId: string, newPassword: string): Promise<void> {
  return apiRequest(`/api/v1/admin/users/${userId}/reset-password`, {
    method: "POST",
    body: JSON.stringify({ new_password: newPassword }),
  });
}
